class Content {
    constructor() {
        this.isInit = false;
        this.header = document.getElementById('header');
        this.topName = document.getElementById('topName');

        this.onHandlerWindowOnScroll = this.handlerWindowOnScroll.bind(this);
    }

    init() {
        if (!this.isInit) {

            this.isInit = true;
            this.bind();
            this.header.classList.add('license');
            this.fixScroll();
        }
    }

    destroy() {
        if (this.isInit) {
            this.isInit = false;
            this.unbind();
        }
    }

    bind() {
        window.addEventListener('scroll', this.onHandlerWindowOnScroll);
    }

    unbind() {
        window.removeEventListener('scroll', this.onHandlerWindowOnScroll);
    }

    handlerWindowOnScroll() {
        this.fixScroll();
    }

    fixScroll() {
        if (window.scrollY > 210) {
            this.topName.classList.remove('hidden');
        } else {
            this.topName.classList.add('hidden');
        }
    }
}

export default Content;